import { useIntl } from "react-intl";

export const MultiLanguageSupportImage = () => {
    const intl = useIntl();

    const messages = {
        altText: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.MultiLanguageSupport.altText",
            defaultMessage: "Example of multi-language support options"
        })
    };

    return (
        <img
            src="https://wac-cdn.atlassian.com/misc-assets/webp-images/Lang_support@1x-from-@harry.webp"
            alt={messages.altText}
            height={350}
            loading="lazy"
        />
    );
};

const MultiLanguageSupport = () => {
    const intl = useIntl();
    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.MultiLanguageSupport.header",
            defaultMessage: "Multi-language support"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.MultiLanguageSupport.body",
            defaultMessage:
                "Meet your customer’s language preferences or requirements by adding any of our 24 supported languages to your service projects."
        }),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.MultiLanguageSupport.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about providing help in other languages."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href="https://support.atlassian.com/jira-service-management-cloud/docs/provide-help-in-multiple-languages/"
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        ),
        caption: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.MultiLanguageSupport.caption",
            defaultMessage:
                "Here’s what adding or removing a language looks like in Jira Service Management."
        })
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.link}</p>
            <MultiLanguageSupportImage />
            <p>{messages.caption}</p>
        </>
    );
};

export default MultiLanguageSupport;
